import React, { useEffect } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { appStore } from "lib/state"
import { cn, queryTools } from "lib/utils"
import { ConditionalSummary } from "lib/units/conditional"
import { useDispute } from "lib/units/dispute/hooks"
import { useStatements } from "."
import { Menubar } from "lib/components"

export default function StatementLogicMenu({ statement, elemtype }:{ statement:any; elemtype:string }){

  const { dspid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams()

  const { store, AppStore }:any = appStore()
  const { update } = AppStore

  const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { id: dspid }, { enabled: !!dspid })
  const saveFn = queryTools.resource.save(["dispute"])
  
  const { cloneStatementInDispute, removeStatementFromDispute, updateConditionalLogicInDispute } = useStatements({ elemtype })
  const { replaceElementConfig } = useDispute({ saveFn })

  const isSelectedResult = (condition:string, action:string) => statement[condition] === action 
  
  /* ===== when user chooses the "if passes" or "if fails" option for a statement ======= */
  const handleResultChange = (condition:string, action:string) => {
    if( statement[condition] !== action ){
      // const newStatement = { ...statement, [condition]: action }
      const newStatements = updateConditionalLogicInDispute(_Dispute, statement.refstr, condition, action)
      replaceElementConfig(_Dispute, elemtype, newStatements)
    }
  }

  const opts:string[] = ["passes", "fails"]
  const submenus = opts.map( (type:string) => ([
    // { 
    //   type: "option", 
    //   refstr: `if_${type}`, 
    //   label: `If statement ${type}`,
    //   visibleFn: () => true,
    // },
    { 
      type: "option", 
      refstr: `if_${type}_content`, 
      label: "Content Only", 
      isSelected: isSelectedResult(`if_${type}`, "content"), 
      selectFn: () => handleResultChange(`if_${type}`, "content") 
    },
    { 
      type: "option", 
      refstr: `if_${type}_content+statement`, 
      label: "Content + Statement", 
      isSelected: isSelectedResult(`if_${type}`, "content+statement"), 
      selectFn: () => handleResultChange(`if_${type}`, "content+statement") 
    },
    { 
      type: "option", 
      refstr: `if_${type}_statement`, 
      label: "Statement Only", 
      isSelected: isSelectedResult(`if_${type}`, "statement"), 
      selectFn: () => handleResultChange(`if_${type}`, "statement") 
    },
    { 
      type: "option", 
      refstr: `if_${type}_nothing`, 
      label: "Nothing", isSelected: 
      isSelectedResult(`if_${type}`, "nothing"), 
      selectFn: () => handleResultChange(`if_${type}`, "nothing") 
    },
    // { type: "divider", refstr: "divider1", label: "---" },
  ]))

  const menu1 = [{
    refstr: "if_passes", 
    label: "Pass",
    visibleFn: () => true,
    submenus: submenus[0]
  }]

  const menu2 = [{
    refstr: "if_fails", 
    label: "Fail",
    visibleFn: () => true,
    submenus: submenus[1]
  }]

  const menu3 = [
    {
      refstr: "actions", 
      label: "Other",
      visibleFn: () => true,
      edge: "right",
      submenus: [
        {
          type: "option",
          refstr: "clone",
          label: "clone",
          selectFn: () => {
            const updatedStatements = cloneStatementInDispute(_Dispute, statement.refstr) 
            console.log("updatedStatements", updatedStatements)
            replaceElementConfig(_Dispute, elemtype, updatedStatements)
          }
        },
        { 
          type: "option",
          refstr: "delete",
          label: "delete", 
          selectFn:() => {
            const updatedStatements = removeStatementFromDispute(_Dispute, statement.refstr)
            replaceElementConfig(_Dispute, elemtype, updatedStatements)
          } 
        }
      ]
    }
  ]

  return (
    <Menubar menus={[...menu1, ...menu2, ...menu3]} className="justify-end" />
  )
}